var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 37.5C0 58.2107 16.7893 75 37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5ZM23.2088 24.2088C21.6672 25.7503 21.6672 28.2497 23.2088 29.7912L30.9176 37.5L23.2088 45.2088C21.6672 46.7503 21.6672 49.2497 23.2088 50.7912C24.7503 52.3328 27.2497 52.3328 28.7912 50.7912L36.5 43.0824L44.2088 50.7912C45.7503 52.3328 48.2497 52.3328 49.7912 50.7912C51.3328 49.2497 51.3328 46.7503 49.7912 45.2088L42.0824 37.5L49.7912 29.7912C51.3328 28.2497 51.3328 25.7503 49.7912 24.2088C48.2497 22.6672 45.7503 22.6672 44.2088 24.2088L36.5 31.9176L28.7912 24.2088C27.2497 22.6672 24.7503 22.6672 23.2088 24.2088Z",
    fill: "#9A2827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTransaction);
export default __webpack_public_path__ + "static/media/failedTransaction.0d58515cfb91582e8dda11d261ec91d8.svg";
export { ForwardRef as ReactComponent };